import { stateModelData } from './models/AdminStateModel'
import { AdminStateService } from './api/AdminStateService'

const StateModule = {
  namespaced: true, // NameSpaced module
  state: stateModelData(),
  getters: {
    fetchStateList: state => state.stateList,
    fetchSearchStateList: state => state.searchStateList,
    fetchStateFipsList: state => state.stateFipsList
  },
  mutations: {
    setList (state, data) {
      state.stateList = data.list
    },
    setSearchStateList (state, data) {
      state.searchStateList = data.list
    },
    setStateFips (state, data) {
      state.stateFipsList = data.list
    }
  },
  actions: {
    /**
     * Attempt Login action handler
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param countryId
     * @param fetchOnlyPublished
     * @param credentials | object
     */
    async getStateList ({ commit }, { resolve, reject, countryId, fetchOnlyPublished }) {
      try {
        const response = await AdminStateService.fetchStateList(countryId, fetchOnlyPublished)
        const { success, data } = response.data
        if (success) {
          commit('setList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async addStateItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminStateService.addStateItem(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getStateList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async editStateItem ({ dispatch }, { resolve, reject, editedData }) {
      try {
        const response = await AdminStateService.editStateItem(editedData)
        const { success, data } = response.data
        if (success) {
          dispatch('getStateList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getStateDetailsById ({ commit }, { resolve, reject, idToGetInfo }) {
      try {
        const response = await AdminStateService.fetchStateDetailsById(idToGetInfo)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async addLocalStateAdoption ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminStateService.addLocalStateAdoption(formData)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getLocalICodeAdoptionById ({ commit }, { resolve, reject, idToGetInfo, userId }) {
      try {
        const response = await AdminStateService.fetchLocalICodeAdoptionById(idToGetInfo, userId)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async validateDeleteStateProfile ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminStateService.validateDeleteStateProfile(formData)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async deleteStateProfile ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminStateService.deleteStateProfile(formData)
        const { success, data } = response.data
        if (success === true) {
          dispatch('getStateList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async searchStateItem ({ commit }, { resolve, reject, searchData }) {
      try {
        const response = await AdminStateService.searchStateItem(searchData)
        const { success, data } = response.data
        if (success === true) {
          commit('setSearchStateList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setSearchStateList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getStateFips ({ commit }, { resolve, reject }) {
      try {
        const response = await AdminStateService.fetchStateFips()
        const { success, data } = response.data
        if (success === true) {
          commit('setStateFips', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setStateFips', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default StateModule
